// @vendors
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @components
import AggregatorSecondPhaseAdvice from './../aggregatorSecondPhaseAdvice/aggregatorSecondPhaseAdvice';
import AggregatorPSD2ExpiredTokenAdvice from './../aggregatorPSD2ExpiredTokenAdvice/aggregatorPSD2ExpiredTokenAdvice';
import AggregatorExpiredOtpAdvice from './../aggregatorExpiredOtpAdvice/aggregatorExpiredOtpAdvice';
import AggregatorGenericAdvice from './../aggregatorGenericAdvice/aggregatorGenericAdvice';

// @actions
import { getSecondFactorAuth } from 'actions/aggregator/aggregatorData';

// @constants
const {
  SECOND_FACTOR_AUTHENTICATION,
  PSD2_SESSION_EXPIRED,
  EXPIRED_SECOND_FACTOR_AUTHENTICATION,
} = require('constants/aggregator/statuses');
import {
  SESSION_EXPIRED,
  AWAITING_MOBILE_BANKID_AUTHENTICATION,
  AWAITING_THIRD_PARTY_APP_AUTHENTICATION,
  AWAITING_SUPPLEMENTAL_INFORMATION,
} from 'constants/aggregator/tinkStatuses.constants';

const secondPhaseStatusAdvice = [
  // Eurobits
  SECOND_FACTOR_AUTHENTICATION,
  // Tink
  AWAITING_MOBILE_BANKID_AUTHENTICATION,
  AWAITING_THIRD_PARTY_APP_AUTHENTICATION,
  AWAITING_SUPPLEMENTAL_INFORMATION,
];
const secondPhaseExpiredStatusAdvice = [
  // Eurobits
  EXPIRED_SECOND_FACTOR_AUTHENTICATION,
  // Tink
  SESSION_EXPIRED,
];
const psd2ExpiredTokenStatus = [
  // Eurobits
  PSD2_SESSION_EXPIRED,
  // Tink
  SESSION_EXPIRED,
];

// @utilities
import { findBanksWithSomeStatuses, getInfoToRenderAdvice } from './../utils/utils';
import getBanksFromAggregatorData from 'utilities/aggregator/getBanksFromAggregatorData';

const findSeveralAdvices = (...adviceStatusAsArguments) =>
  adviceStatusAsArguments.filter(adviceStatus => adviceStatus === true).length > 1;

function AggregatorAdvicesManager({ banks, getSecondFactorAuth }) {
  if (banks.length === 0) return null;

  const expiredTokenBanks = findBanksWithSomeStatuses(banks, psd2ExpiredTokenStatus);
  const secondPhaseBanks = findBanksWithSomeStatuses(banks, secondPhaseStatusAdvice);
  const secondPhaseExpiredBanks = findBanksWithSomeStatuses(banks, secondPhaseExpiredStatusAdvice);

  const [showExpiredTokenAdvice, firstBankWithExpiredToken, existSeveralExpiredTokenBanks] =
    getInfoToRenderAdvice(expiredTokenBanks);

  const [showSecondPhaseAdvice, firstBankWithSecondPhase, existSeveralSecondPhaseBanks] =
    getInfoToRenderAdvice(secondPhaseBanks);

  const [
    showSecondPhaseExpiredAdvice,
    firstBankWithSecondPhaseExpired,
    existSeveralSecondPhaseExpiredBanks,
  ] = getInfoToRenderAdvice(secondPhaseExpiredBanks);

  const existSeveralAdvices = findSeveralAdvices(
    showExpiredTokenAdvice,
    showSecondPhaseAdvice,
    showSecondPhaseExpiredAdvice
  );

  return existSeveralAdvices ? (
    <AggregatorGenericAdvice />
  ) : (
    <Fragment>
      {showExpiredTokenAdvice && (
        <AggregatorPSD2ExpiredTokenAdvice
          bankName={firstBankWithExpiredToken.name}
          bankCode={firstBankWithExpiredToken.code}
          existSeveralBanks={existSeveralExpiredTokenBanks}
        />
      )}
      {showSecondPhaseAdvice && (
        <AggregatorSecondPhaseAdvice
          key="aggregatorAdvice"
          bankName={firstBankWithSecondPhase.name}
          bankId={firstBankWithSecondPhase.userBankId}
          genericMessage={existSeveralSecondPhaseBanks}
        />
      )}
      {showSecondPhaseExpiredAdvice && (
        <AggregatorExpiredOtpAdvice
          key="aggregatorAdvice"
          bankName={firstBankWithSecondPhaseExpired.name}
          userBankId={firstBankWithSecondPhaseExpired.userBankId}
          getSecondFactorAuth={getSecondFactorAuth}
          genericMessage={existSeveralSecondPhaseExpiredBanks}
        />
      )}
    </Fragment>
  );
}

AggregatorAdvicesManager.propTypes = {
  banks: PropTypes.object,
  getSecondFactorAuth: PropTypes.function,
};

export default connect(
  state => ({
    banks: getBanksFromAggregatorData(state.aggregatorData),
  }),
  { getSecondFactorAuth }
)(AggregatorAdvicesManager);
